const BASE_URL = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
const ACTIVE_COOKIE_GROUPS_COOKIE_NAME_ONETRUST = "consentedCookieGroups";
const ONETRUST_LOADED_EVENT = "onetrust-loaded";
const ONETRUST_UPDATE_EVENT = "OneTrustGroupsUpdated";
const LEVELS = {
  LEVEL_ONE: "C0001",
  // "Nödvändiga"
  LEVEL_TWO: "C0002",
  // "Funktionella"
  LEVEL_THREE: "C0003",
  // "Statistiska och analytiska"
  LEVEL_FOUR: "C0004"
  // "Marknadsföring"
};
const COOKIES = {
  // To support the new `onceConsented` or `consented` API in NTSE
  // Each group map to a service that is on the corresponding COOKIE_LEVEL
  C0001: "callguide-chat",
  C0002: "blueconic",
  C0003: "google-maps",
  C0004: "pardot",
  bannerflow: LEVELS.LEVEL_FOUR,
  bankid: LEVELS.LEVEL_THREE,
  blueconic: LEVELS.LEVEL_TWO,
  "callguide-chat": LEVELS.LEVEL_ONE,
  "eam-tcwss": LEVELS.LEVEL_TWO,
  "forum-page-history": LEVELS.LEVEL_TWO,
  ga: LEVELS.LEVEL_TWO,
  globalLevelAlert: LEVELS.LEVEL_TWO,
  "google-analytics": LEVELS.LEVEL_THREE,
  "google-analytics-marketing": LEVELS.LEVEL_FOUR,
  "google-maps": LEVELS.LEVEL_TWO,
  "google-recaptcha": LEVELS.LEVEL_THREE,
  "google-tag-manager": LEVELS.LEVEL_TWO,
  "humany-chattbot": LEVELS.LEVEL_ONE,
  "humany-support": LEVELS.LEVEL_ONE,
  "language-switcher": LEVELS.LEVEL_TWO,
  "msf-favorites": LEVELS.LEVEL_TWO,
  "msf-user-location": LEVELS.LEVEL_TWO,
  "mspa-login": LEVELS.LEVEL_THREE,
  medallia: LEVELS.LEVEL_TWO,
  decibel: LEVELS.LEVEL_TWO,
  navigation: LEVELS.LEVEL_TWO,
  "opf-fc": LEVELS.LEVEL_TWO,
  "pardot-leads-tracking": LEVELS.LEVEL_THREE,
  pardot: LEVELS.LEVEL_FOUR,
  recommendation: LEVELS.LEVEL_THREE,
  salesforce: LEVELS.LEVEL_THREE,
  "salesforce-pardot": LEVELS.LEVEL_THREE,
  "sales-address": LEVELS.LEVEL_TWO,
  sitester: LEVELS.LEVEL_THREE,
  "sergel-chat": LEVELS.LEVEL_THREE,
  "smart-refill-prepaid": LEVELS.LEVEL_ONE,
  whisbi: LEVELS.LEVEL_ONE,
  youtube: LEVELS.LEVEL_THREE,
  "youtube-video": LEVELS.LEVEL_TWO
};

const normalize = (what) => what.filter((group) => !!group).sort().join(",");

const logToSplunk = (activeGroups, originalGroups) => {
  if (originalGroups === "") {
    return;
  }
  const acceptAll = normalize(["C0001", "C0002", "C0003", "C0004"]);
  const reject = "C0001";
  let change = null;
  if (activeGroups === acceptAll) {
    change = "Consent All";
  } else if (activeGroups === reject) {
    change = "Reject All";
  } else {
    change = "Change Consent";
  }
  if (change) {
    logInfo("Cookie Consent", `${change} - ${activeGroups}`);
  }
};
const logInfo = (title, message) => {
  fetch("/.api/frontend-logger-service/v1/log", {
    method: "POST",
    keepalive: true,
    body: JSON.stringify({
      logLevel: "INFO",
      message,
      title
    }),
    headers: { "Content-Type": "application/json" }
  });
};

const reloadPage = () => location.reload();

var w = typeof window !== "undefined" ? window : void 0;

const OneTrustLoaded = () => typeof w?.OptanonWrapper !== "undefined" && typeof w?.OnetrustActiveGroups !== "undefined";

const onetrustStyle = `
:root {
  --brand-color: #990ae3;
  --primary-color: var(--brand-color);
  --primary-color-focus: #7d00bd;
  --secondary-color: white;
  --font-family: "TeliaSans", Helvetica, Arial, "Lucida Grande", sans-serif;
}

#onetrust-banner-sdk p,
#onetrust-banner-sdk a,
#onetrust-banner-sdk h1,
#onetrust-banner-sdk h2,
#onetrust-banner-sdk h3,
#onetrust-banner-sdk h4,
#onetrust-banner-sdk h5,
#onetrust-banner-sdk h6,
#onetrust-banner-sdk span,
#onetrust-banner-sdk ul,
#onetrust-banner-sdk ol,
#onetrust-banner-sdk li,
#onetrust-banner-sdk b,
#onetrust-banner-sdk i,
#onetrust-banner-sdk strong,
#onetrust-banner-sdk italic,
#onetrust-banner-sdk button,
#onetrust-banner-sdk input,
#onetrust-banner-sdk div,
#onetrust-pc-sdk p,
#onetrust-pc-sdk a,
#onetrust-pc-sdk h1,
#onetrust-pc-sdk h2,
#onetrust-pc-sdk h3,
#onetrust-pc-sdk h4,
#onetrust-pc-sdk h5,
#onetrust-pc-sdk h6,
#onetrust-pc-sdk span,
#onetrust-pc-sdk ul,
#onetrust-pc-sdk ol,
#onetrust-pc-sdk li,
#onetrust-pc-sdk b,
#onetrust-pc-sdk i,
#onetrust-pc-sdk strong,
#onetrust-pc-sdk italic,
#onetrust-pc-sdk button,
#onetrust-pc-sdk input,
#onetrust-pc-sdk div{

  font-family: var(--font-family) !important;
}


/* First consent view outside containers */
#onetrust-banner-sdk #onetrust-policy,
#onetrust-banner-sdk .ot-sdk-container {
  margin-left: 0 !important;
  margin-right: 0 !important;
  width: 100%  !important;
}

@media (min-width: 400px) {
  #onetrust-banner-sdk .ot-sdk-container {
    margin-left: 1em !important;
    margin-right: 1em !important;
    width: calc(100% - 2em) !important;
  }
}

@media only screen and (min-width: 768px) {
  #onetrust-banner-sdk .ot-sdk-container {
    margin-left: 32px !important;
    margin-right: 32px !important;
    width: calc(100% - 64px) !important;
  }
}



/* First consent view wrapper*/

#onetrust-banner-sdk .ot-sdk-row {
  display: flex !important;
  flex-direction: column !important;
  margin-top: 16px !important;  
  margin-bottom: 6px !important;
}

@media only screen and (min-width: 768px) {
  #onetrust-banner-sdk .ot-sdk-row {
    margin-top: 32px !important;
    margin-bottom: 22px !important;
  }
}
@media only screen and (min-width: 1024px) {
  #onetrust-banner-sdk .ot-sdk-row {
    flex-direction: row !important;
    max-width: 1338px !important;
    justify-content: space-between !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  #onetrust-banner-sdk .ot-sdk-row:after {
    display: none !important;
  }
  #onetrust-banner-sdk.vertical-align-content #onetrust-button-group-parent {
    width: auto !important;
    margin: 0 !important;
  }
}

/* First consent view policy text*/
#onetrust-banner-sdk #onetrust-policy {
  margin-top: 0 !important;
}

/* Open settings-modal button on first consent view */
#onetrust-button-group button#onetrust-pc-btn-handler {
  color: var(--primary-color) !important;
  border: 1px solid currentColor !important;
  background: var(--secondary-color) !important;
  letter-spacing: 0.4px !important;
  font-weight: 400 !important;
  order: 1;
}
@media only screen and (max-width: 426px) {
  #onetrust-button-group button#onetrust-pc-btn-handler {
    margin-right: 0 !important;
  }
}

#onetrust-banner-sdk #onetrust-pc-btn-handler:hover,
#onetrust-banner-sdk #onetrust-pc-btn-handler:focus {
  opacity: 1 !important;
  background: var(--primary-color) !important;
  color: var(--secondary-color) !important;
}

/*First consent view text container and button group + buttons*/

@media only screen and (min-width: 426px) and (max-width: 896px) {
  #onetrust-banner-sdk:not(.ot-iab-2) #onetrust-group-container {
    width: 100% !important;
    margin-left: 0 !important;
  }
  #onetrust-banner-sdk #onetrust-button-group-parent {
    width: 100% !important;
    position: relative !important;
    margin-left: 0 !important;
  }
  #onetrust-banner-sdk #onetrust-button-group button {
    width: 40% !important;
  }
}
@media only screen and (min-width: 768px) {
  #onetrust-banner-sdk #onetrust-button-group {
    flex-direction: row !important;
    text-align: left  !important;
  }
  #onetrust-banner-sdk #onetrust-button-group button {
    width: auto !important;
    padding: 12px 24px  !important;
  }
}
#onetrust-button-group button {
  border-radius: 35px !important;
  margin: 10px 0 !important;
}



/* Approve button on first consent view */
#onetrust-button-group button#onetrust-accept-btn-handler,
#onetrust-button-group button#onetrust-reject-all-handler,
/* Approve ALL button inside settings-modal */
#ot-pc-content button#accept-recommended-btn-handler,
.ot-pc-footer .ot-btn-container button.save-preference-btn-handler.onetrust-close-btn-handler {
  color: var(--secondary-color) !important;
  border: 1px solid currentColor !important;
  background: var(--primary-color) !important;
  letter-spacing: 0.4px !important;
  font-weight: 400 !important;
}

/* Decline button on first consent view */
#onetrust-button-group button#onetrust-accept-btn-handler {
  font-weight: 600 !important;
  color: #ffffff !important;
  order: 0;
}

#onetrust-button-group button#onetrust-reject-all-handler {
  color: var(--primary-color) !important;
  background: white !important;
  font-weight: normal;
  order: 2;
}

/* Style for buttons on first consent view */
#onetrust-banner-sdk #onetrust-button-group {
  flex-direction: column;
  display: flex !important;
  gap: 1rem;
}

@media only screen and (max-width: 600px) {
  #onetrust-banner-sdk #onetrust-accept-btn-handler,
  #onetrust-banner-sdk #onetrust-pc-btn-handler {
    width: 100% !important;
  } 
}
@media only screen and (max-width: 800px) {
  #onetrust-banner-sdk #onetrust-button-group {
    display: flex !important;
  }
}
@media only screen and (min-width: 800px) {
  #onetrust-banner-sdk #onetrust-button-group-parent {
    text-align: left !important;
  }
}
@media only screen and (min-width: 897px) {
  #onetrust-banner-sdk.vertical-align-content #onetrust-button-group-parent {
    position: static !important;
    transform: none !important;
    width: auto !important;
  }
}
@media only screen and (min-width: 550px) {
  #onetrust-banner-sdk .ot-sdk-column,
  #onetrust-banner-sdk .ot-sdk-columns,
  #onetrust-pc-sdk .ot-sdk-column,
  #onetrust-pc-sdk .ot-sdk-columns,
  #ot-sdk-cookie-policy .ot-sdk-column,
  #ot-sdk-cookie-policy .ot-sdk-columns {
    margin-left: 12px !important;
  }
}


/* More info link in settings-modal */
#onetrust-consent-sdk #onetrust-pc-sdk .privacy-notice-link {
  color: var(--primary-color) !important;
}

/* Text both in first consent popup and settings-modal */
#onetrust-banner-sdk div, #onetrust-banner-sdk span, #onetrust-banner-sdk h1, #onetrust-banner-sdk h2, #onetrust-banner-sdk h3, #onetrust-banner-sdk h4, #onetrust-banner-sdk h5, #onetrust-banner-sdk h6, #onetrust-banner-sdk p, #onetrust-banner-sdk img, #onetrust-banner-sdk svg, #onetrust-banner-sdk button, #onetrust-banner-sdk section, #onetrust-banner-sdk a, #onetrust-banner-sdk label, #onetrust-banner-sdk input, #onetrust-banner-sdk ul, #onetrust-banner-sdk li, #onetrust-banner-sdk nav, #onetrust-banner-sdk table, #onetrust-banner-sdk thead, #onetrust-banner-sdk tr, #onetrust-banner-sdk td, #onetrust-banner-sdk tbody, #onetrust-banner-sdk .ot-main-content, #onetrust-banner-sdk .ot-toggle, #onetrust-banner-sdk #ot-content, #onetrust-banner-sdk #ot-pc-content, #onetrust-banner-sdk .checkbox, #onetrust-pc-sdk div, #onetrust-pc-sdk span, #onetrust-pc-sdk h1, #onetrust-pc-sdk h2, #onetrust-pc-sdk h3, #onetrust-pc-sdk h4, #onetrust-pc-sdk h5, #onetrust-pc-sdk h6, #onetrust-pc-sdk p, #onetrust-pc-sdk img, #onetrust-pc-sdk svg, #onetrust-pc-sdk button, #onetrust-pc-sdk section, #onetrust-pc-sdk a, #onetrust-pc-sdk label, #onetrust-pc-sdk input, #onetrust-pc-sdk ul, #onetrust-pc-sdk li, #onetrust-pc-sdk nav, #onetrust-pc-sdk table, #onetrust-pc-sdk thead, #onetrust-pc-sdk tr, #onetrust-pc-sdk td, #onetrust-pc-sdk tbody, #onetrust-pc-sdk .ot-main-content, #onetrust-pc-sdk .ot-toggle, #onetrust-pc-sdk #ot-content, #onetrust-pc-sdk #ot-pc-content, #onetrust-pc-sdk .checkbox, #ot-sdk-cookie-policy div, #ot-sdk-cookie-policy span, #ot-sdk-cookie-policy h1, #ot-sdk-cookie-policy h2, #ot-sdk-cookie-policy h3, #ot-sdk-cookie-policy h4, #ot-sdk-cookie-policy h5, #ot-sdk-cookie-policy h6, #ot-sdk-cookie-policy p, #ot-sdk-cookie-policy img, #ot-sdk-cookie-policy svg, #ot-sdk-cookie-policy button, #ot-sdk-cookie-policy section, #ot-sdk-cookie-policy a, #ot-sdk-cookie-policy label, #ot-sdk-cookie-policy input, #ot-sdk-cookie-policy ul, #ot-sdk-cookie-policy li, #ot-sdk-cookie-policy nav, #ot-sdk-cookie-policy table, #ot-sdk-cookie-policy thead, #ot-sdk-cookie-policy tr, #ot-sdk-cookie-policy td, #ot-sdk-cookie-policy tbody, #ot-sdk-cookie-policy .ot-main-content, #ot-sdk-cookie-policy .ot-toggle, #ot-sdk-cookie-policy #ot-content, #ot-sdk-cookie-policy #ot-pc-content, #ot-sdk-cookie-policy .checkbox, #ot-sync-ntfy div, #ot-sync-ntfy span, #ot-sync-ntfy h1, #ot-sync-ntfy h2, #ot-sync-ntfy h3, #ot-sync-ntfy h4, #ot-sync-ntfy h5, #ot-sync-ntfy h6, #ot-sync-ntfy p, #ot-sync-ntfy img, #ot-sync-ntfy svg, #ot-sync-ntfy button, #ot-sync-ntfy section, #ot-sync-ntfy a, #ot-sync-ntfy label, #ot-sync-ntfy input, #ot-sync-ntfy ul, #ot-sync-ntfy li, #ot-sync-ntfy nav, #ot-sync-ntfy table, #ot-sync-ntfy thead, #ot-sync-ntfy tr, #ot-sync-ntfy td, #ot-sync-ntfy tbody, #ot-sync-ntfy .ot-main-content, #ot-sync-ntfy .ot-toggle, #ot-sync-ntfy #ot-content, #ot-sync-ntfy #ot-pc-content, #ot-sync-ntfy .checkbox {
  font-size: 1.6rem !important;
  color: #222 !important;
}

/* Buttons in settings-modal (the not ignores a lot of "elemnts" eg, cookie-group accordion)*/
#onetrust-consent-sdk #onetrust-pc-sdk button:not(#clear-filters-handler):not(.ot-close-icon):not(#filter-btn-handler):not(.ot-remove-objection-handler):not(.ot-obj-leg-btn-handler):not([aria-expanded]):not(.ot-link-btn),
#onetrust-consent-sdk #onetrust-pc-sdk .ot-leg-btn-container .ot-active-leg-btn {
  color: var(--secondary-color) !important;
  border: 1px solid currentColor !important;
  background: var(--primary-color) !important;
  letter-spacing: 0.4px !important;
  font-weight: 400 !important;
}

/* toggle switch for consenting different levels in the settings-modal */
#onetrust-pc-sdk .ot-switch-nob {
  background-color: var(--purpur-color-background-interactive-inactive) !important;
}
#onetrust-pc-sdk .ot-tgl input:checked+.ot-switch .ot-switch-nob {
  background-color: var(--secondary-color) !important;
  border: 1px solid var(--primary-color) !important;
}
#onetrust-pc-sdk .ot-tgl input:checked+.ot-switch .ot-switch-nob:before {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}


/* Primary buttons, hover and focus styling */
#onetrust-banner-sdk #onetrust-accept-btn-handler:hover,
#onetrust-banner-sdk #onetrust-accept-btn-handler:focus,
#onetrust-banner-sdk #onetrust-reject-btn-handler:hover,
#onetrust-banner-sdk #onetrust-reject-btn-handler:focus,
#onetrust-consent-sdk #onetrust-pc-sdk button:not(#clear-filters-handler):not(.ot-close-icon):not(#filter-btn-handler):not(.ot-remove-objection-handler):not(.ot-obj-leg-btn-handler):not([aria-expanded]):not(.ot-link-btn):hover,
#onetrust-consent-sdk #onetrust-pc-sdk button:not(#clear-filters-handler):not(.ot-close-icon):not(#filter-btn-handler):not(.ot-remove-objection-handler):not(.ot-obj-leg-btn-handler):not([aria-expanded]):not(.ot-link-btn):focus,
#onetrust-consent-sdk #onetrust-pc-sdk .ot-leg-btn-container .ot-active-leg-btn:hover,
#onetrust-consent-sdk #onetrust-pc-sdk .ot-leg-btn-container .ot-active-leg-btn:focus {
  opacity: 1 !important;
  background: var(--primary-color-focus) !important;
}

/* Settins-modal close icon*/
#close-pc-btn-handler:hover,
#close-pc-btn-handler:focus {
  opacity: 1 !important;
}

/* Settings-modal "body" mobile styling*/
@media only screen and (max-width: 600px) {
  #onetrust-pc-sdk #ot-pc-content {
    padding-right: 16px !important;
    margin: 0 0 0 16px !important;
    width: calc(100% - 32px) !important;
    bottom: 160px !important;
  }

}
/* Settings-modal footer*/
#onetrust-pc-sdk .ot-pc-footer {
  padding: 0 16px !important;
  width: calc(100% - 32px) !important;
}

/* Cookie consent logo (we don't want to show it on Telia.se) */
#ot-sdk-btn-floating,
#onetrust-pc-sdk .ot-pc-logo {
  display: none !important; 
}

#onetrust-group-container {
  width: 100%;
}

/* Banner */
#onetrust-button-group button {
  border-radius: 35px;
  margin: 10px 0 !important;
}

/* Preference view */
.ot-btn-container button {
  border-radius: 35px !important;
}
#accept-recommended-btn-handler {
  border-radius: 35px !important;
}
.ot-pc-header .ot-pc-logo, .ot-pc-footer .ot-pc-footer-logo {
  display: none !important;
  visibility: hidden !important;
}

/* Fix for height issue in legacy. Should be removed once legacy is no longer used */
#onetrust-consent-sdk #onetrust-pc-sdk {
  min-height: 600px;
}

`;

const insertOneTrustScript = (src, cookieGroup, description) => {
  if (!description) {
    console.warn("Please provide a description of why you need this script.");
  }
  function appendScript() {
    w?.OneTrust?.InsertScript(src, "head", null, null, cookieGroup);
  }
  if (w) {
    if (w.OneTrust) {
      appendScript();
    } else {
      w.addEventListener(ONETRUST_LOADED_EVENT, appendScript);
    }
  }
};
const injectPriorityOneTrustScript = (group, scriptSrc, description) => {
  if (!description) {
    console.warn("Please provide a description of why you need this script:", scriptSrc);
  }
  return `
    (() => {
      const consentedGroups = document.cookie.split(';').find(str => str.match('${ACTIVE_COOKIE_GROUPS_COOKIE_NAME_ONETRUST}='));
      if (consentedGroups) {
        const group = ${JSON.stringify(group)};
        const consented = consentedGroups.includes(group);
        if (consented) {
          const script = document.createElement("script");
          script.src = "${scriptSrc}";
          script.async = true;
          document.head.appendChild(script);
        }
      }
    })()
  `;
};
const isConsented = (cookieGroup, description) => {
  if (!description) {
    console.warn("Please provide a description of why you need this script.");
  }
  const activeGroups = consentedCookieGroups();
  if (Array.isArray(cookieGroup)) {
    return cookieGroup.every((group) => activeGroups.includes(group));
  } else {
    return activeGroups.some((group) => group === cookieGroup);
  }
};
const onceConsented$1 = (cookieGroup, description) => {
  return new Promise((resolve) => {
    const callback = () => {
      if (isConsented(cookieGroup, description)) {
        try {
          w?.removeEventListener(ONETRUST_UPDATE_EVENT, callback);
          resolve();
        } catch (e) {
          console.warn(`b2x-cookie-consent failed executing consent callback`, e);
        }
      }
    };
    if (w && isConsented(cookieGroup, description) && OneTrustLoaded()) {
      resolve();
    } else {
      w?.addEventListener(ONETRUST_UPDATE_EVENT, callback);
    }
  });
};
const setOneTrustConsentedValue = (value, date) => {
  const encodedValue = encodeURIComponent(value);
  document.cookie = `${ACTIVE_COOKIE_GROUPS_COOKIE_NAME_ONETRUST}=${encodedValue};expires=${date.toUTCString()};path=/;SameSite=Lax`;
};
const consentedCookieGroups = () => {
  const groups = document.cookie.split(";").find((x) => x.trim().startsWith("consentedCookieGroups="))?.split("=")[1];
  if (!groups) {
    return [];
  }
  const decodedGroups = decodeURIComponent(groups)?.split(",");
  return decodedGroups.filter((group) => !!group);
};
const openOneTrustPreferences = () => {
  if (w?.OneTrust) {
    w?.OneTrust?.ToggleInfoDisplay();
  }
};
const onConsentUpdate = (callback) => {
  if (OneTrustLoaded() && w?.OneTrust?.IsAlertBoxClosed()) {
    return callback(consentedCookieGroups());
  } else {
    w?.addEventListener(ONETRUST_UPDATE_EVENT, () => {
      if (w?.OneTrust?.IsAlertBoxClosed()) {
        callback(consentedCookieGroups());
      }
    });
  }
};
const initCookieConsentStyleOverrides = () => {
  const styleId = "cookie-consent-overrides";
  if (!w || document.getElementById(styleId)) return;
  const style = document.createElement("style");
  style.id = styleId;
  style.textContent = onetrustStyle;
  document.head.appendChild(style);
};
const appendOneTrustScript = (src, token) => {
  const script = document.createElement("script");
  script.async = true;
  script.src = src;
  script.dataset.domainScript = token;
  script.dataset.documentLanguage = "true";
  document.head.appendChild(script);
};
const SUPPORTED_LANGUAGES = ["sv", "en"];
let isObservingDocumentLanguage = false;
const getDocumentLanguage = () => {
  const lang = document.documentElement.lang.split("-")[0].toLowerCase();
  return SUPPORTED_LANGUAGES.includes(lang) ? lang : void 0;
};
const observeDocumentLanguage = () => {
  if (!w || isObservingDocumentLanguage) return;
  isObservingDocumentLanguage = true;
  let appliedLanguage = getDocumentLanguage();
  let pendingLanguage;
  const applyLanguage = (lang) => {
    if (lang === appliedLanguage) {
      pendingLanguage = void 0;
      return;
    }
    if (typeof w?.OneTrust?.changeLanguage === "function") {
      pendingLanguage = void 0;
      appliedLanguage = lang;
      w.OneTrust.changeLanguage(lang);
    } else {
      pendingLanguage = lang;
    }
  };
  w.addEventListener(ONETRUST_LOADED_EVENT, () => {
    if (pendingLanguage) {
      applyLanguage(pendingLanguage);
    }
  });
  new MutationObserver(() => {
    const lang = getDocumentLanguage();
    if (lang) {
      applyLanguage(lang);
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });
};
const oneTrustInit = (token, src = BASE_URL) => {
  if (typeof w?.OptanonWrapper !== "undefined" || w === void 0) {
    return;
  }
  const triggerLoad = () => {
    const newEv = new CustomEvent(ONETRUST_LOADED_EVENT);
    w?.dispatchEvent(newEv);
  };
  let original = (w?.OnetrustActiveGroups || "").split(",");
  function OptanonWrapper() {
    triggerLoad();
    const current = (w?.OnetrustActiveGroups || "").split(",");
    const activeGroups = current.filter((group) => group).join(",");
    const date = /* @__PURE__ */ new Date();
    date.setFullYear(date.getFullYear() + 1);
    date.setDate(date.getDate() - 1);
    setOneTrustConsentedValue(activeGroups, date);
    const currentCookiesGroups = normalize(current);
    const originalCookiesGroups = normalize(original);
    if (currentCookiesGroups !== originalCookiesGroups) {
      logToSplunk(currentCookiesGroups, originalCookiesGroups);
    }
    const shouldReload = originalCookiesGroups && currentCookiesGroups.length < originalCookiesGroups.length;
    if (shouldReload) {
      reloadPage();
    }
    original = current;
  }
  w.OptanonWrapper = OptanonWrapper;
  if (OneTrustLoaded()) {
    triggerLoad();
  }
  initCookieConsentStyleOverrides();
  appendOneTrustScript(src, token);
  observeDocumentLanguage();
};

const init = async (token, src = BASE_URL) => {
  oneTrustInit(token, src);
};
const consented = (cookieGroup, description) => isConsented(cookieGroup, description);
const injectPriorityScript = (group, scriptSrc, description) => injectPriorityOneTrustScript(group, scriptSrc, description);
const openPreferences = () => openOneTrustPreferences();
const onConsented = (callback) => {
  return onConsentUpdate(callback);
};
const insertScript = (src, cookieGroup, description) => insertOneTrustScript(src, cookieGroup, description);
const onceConsented = (cookieGroup, description) => onceConsented$1(cookieGroup, description);
const ensureCookieConsent = async (cookieGroup, description) => {
  if (consented(cookieGroup, description)) {
    return true;
  }
  openPreferences();
  try {
    await onceConsented(cookieGroup, description);
    return true;
  } catch (error) {
    console.warn(`Cookie consent not granted for ${cookieGroup}:`, error);
    return false;
  }
};

export { COOKIES, consented, ensureCookieConsent, init, injectPriorityScript, insertScript, onConsented, onceConsented, openPreferences };
//# sourceMappingURL=b2x-cookie-consent.esm.js.map
